module.exports = __webpack_public_path__ + "img/ctrl-magic-stub-mid--.405a85ff.svg";